import { Button } from "@chakra-ui/react";
import React from "react";
import { BsFillPrinterFill } from "react-icons/bs";

function PrintButton(props) {
  return (
    <>
      <Button
        alignContent={"flex-end"}
        rightIcon={<BsFillPrinterFill />}
        colorScheme="blue"
        variant="outline"
        onClick={window.print}
      >
        Imprimir
      </Button>
    </>
  );
}

export default PrintButton;
